

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { TD1AdminForm } from "../../components/TD1AdminForm";


export const TD1AdminFormPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="TD1 Form's"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "TD1 Form's", navigateTo: "/form/admin/td1" }
      ]}
      mainContents={<TD1AdminForm />}
    />
  );
};
